@if ({
  isHomePage: isHomePage$ | async,
  largeScreenDownObserver: largeScreenDownObserver$ | async,
  footerVisible: footerVisible$ | async,
  }; as componentData) {
  <app-header id="sticky-app-header" class="sticky-top" [isHomePage]="componentData.isHomePage" [class.home-page]="componentData.isHomePage" />
  <main class="flex-1" [class.home-page-main]="componentData.isHomePage"><router-outlet /></main>
  @if ((!componentData.largeScreenDownObserver || componentData.isHomePage) && componentData.footerVisible) {
    <app-footer [class.home-spacing]="componentData.isHomePage" />
  }
  @if (componentData.isHomePage) {
    <app-mobile-navigation class="d-block d-lg-none" />
  }
}
